/**
 * Christmas emotes — authored via the `/pack` toile process (plan
 * `thinking/plans/2026_08_31_toile_pack_wiring.md` Track B), wave `toile_seasons`. Narcis file-split
 * shape (Track A): one module per pack, `registry.ts` assembles them into `livePacks`.
 */
import {tagline, chips, type ToilePack} from './data'

export const christmasEmotesPack: ToilePack = {
    slug: 'christmas-emotes',
    category: 'season',
    name: 'Christmas emotes',
    tagline: tagline('pieces', 'themes', 'styles'),
    chips: chips('themes', 'styles'),
    ratio: {w: 1024, h: 1024},
    readings: [
        {key: 'hype', label: 'Hype hat', subject: 'a round face wearing a santa hat with wide excited eyes and an open grin, built to read tiny'},
        {key: 'melt', label: 'Melting snowman', subject: 'a round snowman face drooping with a sad mouth and a drip, built to read tiny'},
        {key: 'sip', label: 'Cocoa sip', subject: 'a round face with closed happy eyes sipping cocoa with marshmallows, built to read tiny'},
    ],
    styles: [
        {key: 'scandi', label: 'Scandi folk', style: 'scandinavian folk illustration, simplified shapes, no outlines, matte flat colour', palette: 'A limited palette of red, white, forest green and a touch of gold.', framing: 'Centered on a solid cream background, built to read clean at small size.'},
        {key: 'vintage', label: 'Vintage card', style: 'mid-century christmas card illustration, soft halftone grain, slight misregistration', palette: 'Muted red, pine green, cream and a faded gold.', framing: 'Centered on an aged cream paper background with an even margin.'},
        {key: 'cozy', label: 'Cozy cartoon', style: 'cozy cartoon illustration, rounded shapes, thick soft outlines, warm and friendly', palette: 'Warm reds and greens with a glowing amber and snow white.', framing: 'Centered on a solid background with a little room around it.'},
    ],
    directions: ['a laughing elf instead', 'for a discord server', 'with tears instead of joy'],
    directionHint: 'try: a laughing elf instead',
    seo: {
        title: 'Christmas Emotes: Hype, Melting, Cocoa Sip',
        metaDescription: 'Nine christmas emotes -- hyped santa hat, melting snowman, cocoa sip -- in scandi folk, vintage card, and cozy cartoon finishes. Built for chat.',
        h1: 'Christmas emotes: hyped santa hat, melting snowman, and cocoa sip',
        tagline: 'Nine faces, three chat moods, three finishes each.',
        intro: 'Nine christmas emote designs, built to read tiny in a chat window: a hyped santa-hat face, a melting snowman, and a happy cocoa sip. Three finishes -- scandi folk, vintage card, and cozy cartoon -- for Twitch, Discord, or any chat platform. Ask for a laughing elf instead, or tears instead of joy, and the same three finishes carry it.',
        useCases: [
            'a Twitch channel emote',
            'a Discord server emoji',
            'a chat sticker pack',
            'a stream overlay accent',
        ],
        faq: [
            {q: 'What does this pack actually look like?', a: 'Nine round emote designs -- a hyped face, a melting snowman, and a cocoa sip -- each in scandi folk, vintage card, and cozy cartoon finishes, built to read at tiny chat sizes.'},
            {q: 'What size do platforms need for emotes?', a: 'Twitch and Discord both accept the full-resolution image and downscale it themselves -- export the design and upload it directly.'},
            {q: 'Can I get a different mood, like a laughing elf?', a: 'Yes -- the direction field takes any variation, including a laughing elf instead, tears instead of joy, or a Discord-specific crop.'},
            {q: 'Can I sell these as emotes to my community?', a: 'Yes -- the designs are yours to upload and use across any streaming or chat platform you run.'},
        ],
    },
}
